import React, { useEffect } from 'react';
import { Redirect, Route } from 'react-router-dom';
import { getToken, isWhitelabel } from '../Utils/token';
import { useLocation } from 'react-router';
import { scrollTo } from '../Utils';

const PrivateRoutes = ({ component: Component, trackPage, ...rest }) => {
  const userToken = getToken() ? true : isWhitelabel();
  const { pathname } = useLocation();

  useEffect(() => {
    scrollTo(); // scrolls to top
  }, [pathname]); // runs on route change

  return (
    <Route {...rest} render={props => {
      return (
        (userToken ?
          <Component {...props} {...rest} />
          :
          <Redirect to={{ pathname: '/', state: { from: props.location } }} />
        )
      )
    }
    } />
  );
};

export default PrivateRoutes; 